module.exports = __webpack_public_path__ + "img/txt.e1ec5b38.png";